import { useSelector } from "react-redux";
import { StateExtended } from "../../_config/interfaces/stateExtended";

export const useAppLoaderSelector = () => useSelector((state: StateExtended) => state.loader.fpLoader);
export const useMenuCollapseSelector = () => useSelector((state: StateExtended) => state.loader.menuCollapse);
export const useSearchingSelector = () => useSelector((state: StateExtended) => state.loader.searching);
